export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01-4.f74156d9.svg";